export default "__VITE_ASSET__D1yd3$zd__"